<template>
  <DragDialog
    title="批量授权"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :width="800"
    :submit="submit"
    :cancel="cancel">
    <div class="batch-grant-box">
      <div class="grant-tree-box">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="mini"
            placeholder="请输入功能名称"
            v-model="keywords"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>
        <div class="grant-tree">
          <div class="grant-tree-header">
            <span class="dialog-label">功能管理</span>
            <div class="icon-btn-box">
              <i
                v-show="openSilderMenu"
                class="el-icon-arrow-up"
                @click="setAllExpand(true)"
                title="展开全部"></i>
              <i
                v-show="!openSilderMenu"
                class="el-icon-arrow-down"
                @click="setAllExpand(false)"
                title="折叠全部"></i>
              <!-- <icon-svg
                icon-class="ic-ico_open"
                class="icon"
                title="展开全部"
                @click.native="setAllExpand(true)"
              />
              <icon-svg
                icon-class="ic-ico_Stow"
                class="icon"
                title="折叠全部"
                @click.native="setAllExpand(false)"
              /> -->
            </div>
          </div>
          <div class="common-tree-box">
            <el-tree
              class="dialog-tree-primary"
              ref="tree"
              :data="treeData"
              :props="defaultProps"
              node-key="id"
              :check-strictly="false"
              default-expand-all
              :expand-on-click-node="false"
              highlight-current
              :filter-node-method="filterNode"
              @check-change="handleCheckChange"
              show-checkbox />
          </div>
        </div>
      </div>
      <div class="role-list-box">
        <div class="role-list-header">
          <p>角色列表</p>
        </div>
        <div class="common-table-box">
          <el-table
            :data="roleList"
            class="publish-table"
            height="100%"
            highlight-selection-row
            @select="selectChange"
            @select-all="selectChange"
            ref="groupTable">
            <el-table-column
              type="selection"
              width="60" />
            <el-table-column
              label="角色名称"
              prop="roleName" />
            <el-table-column
              label="角色说明"
              prop="description" />
            <template slot="empty">
              <div class="empty-box">
                <bj-empty
                  :image="require('@/assets/img/no-data.png')"
                  class="empty-page">
                  <template slot="description">
                    暂无角色数据，请创建角色后再进行授权
                  </template>
                </bj-empty>
              </div>
            </template>
          </el-table>
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import {
  getPermissionMenu,
  getRoleListService,
  grantRole
} from '@/service/interface'

export default {
  data() {
    return {
      keywords: '',
      treeData: [],
      defaultProps: {
        children: 'childNodes',
        label: 'menuName'
      },
      openSilderMenu: true,
      roleList: [],
      selectRoles: []
    }
  },
  props: {
    visible: Boolean,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.queryPermissionTree()
        this.queryRoleList()
      }
    }
  },
  methods: {
    handleCheckChange(node, isChecked) {
      // 调试用：实时打印父节点状态
      if (node.parent) {
        console.log(`父节点 ${node.parent.id} 状态:`, {
          checked: node.parent.checked,
          indeterminate: node.parent.indeterminate
        })
      }
    },
    queryPermissionTree() {
      let params = {
        roleId: null,
        menuName: ''
      }
      getPermissionMenu(params).then(result => {
        if (result.status === 200) {
          let response = result.data
          if (response.isSuccess) {
            let treeData = response.data
            this.treeData = treeData
          } else {
            this.$message.error(response.errMsg)
          }
        }
      })
    },
    queryRoleList() {
      let params = {
        maxResultCount: 1000,
        skipCount: 0,
        sorting: '',
        roleName: ''
      }
      getRoleListService(params).then(result => {
        if (result.status === 200) {
          let response = result.data
          if (response.isSuccess) {
            let data = response.data
            let roleList = data.items
            this.roleList = roleList
          } else {
            this.$message.error(response.errMsg)
          }
        }
      })
    },
    submit() {
      let node = this.$refs.tree.store._getAllNodes()
      let grantInfos = node.map(item => {
        let obj = {
          id: item.data.id,
          isGranted: item.checked,
          code: item.data.permissionCode
        }
        return obj
      })
      let roleIds = this.selectRoles.map(el => el.roleId)

      let params = { roleIds, grantInfos }
      grantRole(params).then(result => {
        if (result.status === 200) {
          let response = result.data
          if (response.isSuccess) {
            this.$message.success('批量授权成功')
            this.cancel()
          } else {
            this.$message.error(response.errMsg)
          }
        }
      })
    },
    cancel() {
      this.closeDialog()
    },
    selectChange(selection) {
      this.selectRoles = selection
    },
    setAllExpand(state) {
      let nodes = this.$refs.tree.store._getAllNodes()
      for (let i in nodes) {
        nodes[i].expanded = state
      }
      this.openSilderMenu = !this.openSilderMenu
    },
    search() {
      this.$nextTick(() => {
        this.$refs.tree.filter()
      })
    },
    filterNode(value, nodeData) {
      if (nodeData.menuName.includes(this.keywords)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.batch-grant-box {
  display: flex;
  height: 500px;
  color: var(--default-color);

  .grant-tree-box {
    width: 240px;
    padding: 10px 15px;
    border-radius: 5px;

    .grant-tree {
      height: calc(100% - 70px);
      margin-top: 10px;
      .grant-tree-header {
        display: flex;
        justify-content: space-between;
        line-height: 30px;

        .icon {
          margin-left: 10px;
          color: var(--icon-color);
          font-size: 14px;
          cursor: pointer;

          &:hover {
            color: var(--primary-color);
          }
        }
      }

      .common-tree-box {
        height: 100%;
      }
    }
  }

  .role-list-box {
    width: calc(100% - 260px);
    margin-left: 20px;
    text-align: left;

    .role-list-header {
      height: 30px;
      line-height: 30px;

      p {
        height: 20px;
        line-height: 10px;
        margin: 5px 0px;
        padding: 4px 10px;
        border-left: 4px solid var(--base-primary-color);
      }
    }

    .common-table-box {
      height: calc(100% - 36px);
    }
  }
}
</style>
